import { FC, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { copy } from "shared/assets";

import { useBandContext, usePermissionsContext } from "Bands/contexts";
import { dispatchGetBandUsersPermissions, groupPermissionsSelectorCreator } from "Bands/state";
import { useSelector } from "react-redux";
import { List, Message, Modal } from "shared/components";
import { Spacer } from "shared/layout";
import { IStatus } from "shared/types";
import { PermissionsTableEdit } from "../permissions/containers/PermissionsTableEdit";

const { messages } = copy.permissions.editPermissions;

interface Props {
  handleClose: () => void;
  groupId: string;
}

export const RedirectToCustomEventBlockPermissionsModal: FC<Props> = ({ handleClose, groupId }) => {
  const dispatch = useDispatch();
  const { bandId } = useBandContext();
  const { rootGroupPermissions } = usePermissionsContext();

  const groupPermissionsSelector = useMemo(
    () => groupPermissionsSelectorCreator(groupId),
    [groupId]
  );
  const groupPermissions = useSelector(groupPermissionsSelector);

  const permissions = useMemo(
    () => rootGroupPermissions?.[groupId],
    [groupId, rootGroupPermissions]
  );

  // Load group permissions data when component mounts
  useEffect(() => {
    if (!bandId || !permissions?.length || groupPermissions) return;

    dispatchGetBandUsersPermissions({
      dispatch,
      bandId,
      permissionTypes: permissions.map(({ id }) => id),
      rootGroupId: groupId,
    });
  }, [bandId, permissions, groupId, groupPermissions, dispatch]);

  if (!groupPermissions) return null;

  return (
    <Modal handleClose={handleClose}>
      <Spacer size="l">
        <Message status={IStatus.info}>
          {messages.redirectToCustomEventBlockPermissions1}
          <br />
          {messages.redirectToCustomEventBlockPermissions2}
        </Message>
        <PermissionsTableEdit users={groupPermissions} handleClose={handleClose} />
      </Spacer>
    </Modal>
  );
};
